import { useCallback, useMemo } from "react";

import { useEventTrackerService } from "@vahak/core/dist/_services/hooks/useEventTrackerService";

import { TrackEventHandler } from "../../../types/events";
import { useWebV2PageOpened } from "./useWebV2PageOpened";

type UseWebV2TrackerOptions = {
    sourceScreen: string;
    pageOpenedEventName?: string;
};

/**
 * Shared WEB_V2 tracking setup for top-level pages.
 *
 * Creates a stable `trackEvent`, injects `source_screen` as common `eventData`,
 * and optionally fires a page-opened event once on mount.
 */
export function useWebV2Tracker({ sourceScreen, pageOpenedEventName }: UseWebV2TrackerOptions) {
    const { sendGAandMoEngageEvent } = useEventTrackerService();

    const trackEvent: TrackEventHandler = useCallback(
        (eventName, data, trackGa = true, trackMo = true, trackFbCapi = false) => {
            sendGAandMoEngageEvent({ name: eventName, data }, trackGa, trackMo, trackFbCapi);
        },
        [sendGAandMoEngageEvent]
    );

    const eventData = useMemo(() => ({ source_screen: sourceScreen }), [sourceScreen]);

    useWebV2PageOpened(trackEvent, pageOpenedEventName, eventData);

    return { trackEvent, eventData };
}
